import {
  PendingTopup,
  TopupWithState,
  VALID_TOPUP_STATES,
} from '@/src/api/payg';
import { useStorageState } from '@/src/utils/useStorageState';
import React, { useEffect } from 'react';
import { FinalNotification } from './FinalNotification';

type Props = {
  topups: TopupWithState<PendingTopup, VALID_TOPUP_STATES>[];
};

export const FinalNotifications = ({ topups }: Props) => {
  const [dismissedTopups, setDismissedTopups] = useStorageState<string[]>(
    'dismissedPaygTopups',
    [],
  );

  useEffect(() => {
    setDismissedTopups(
      dismissedTopups.filter(id =>
        topups.some(topup => topup.topupSessionId === id),
      ),
    );
  }, [dismissedTopups, setDismissedTopups, topups]);

  const topupsWithoutDismissed = topups.filter(
    topup => !dismissedTopups.includes(topup.topupSessionId),
  );

  return topupsWithoutDismissed.map(topup => (
    <FinalNotification
      key={topup.topupSessionId}
      topup={topup}
      onDismiss={() =>
        setDismissedTopups([...dismissedTopups, topup.topupSessionId])
      }
    />
  ));
};
